import React from "react";

import TopBar from "./TopBar/TobBar";
import Footer from "./Footer/Footer";

import defaultStyle from "./Layout.module.scss";
import { CourseWithChapters } from "@jelly/lesson";

interface LayoutProps {
  headerText?: string;
  headerUrl?: string;
  onHeaderClick?: () => void;
  course?: CourseWithChapters;
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({ children, headerText, headerUrl, onHeaderClick }: LayoutProps) => {
  return (
    <div className={defaultStyle.container}>
      <TopBar headerText={headerText} headerUrl={headerUrl} onHeaderClick={onHeaderClick} />
      <div className={defaultStyle.content}>{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
